import { i as copy_payload, j as assign_payload, p as pop, a as push, h as head, e as escape_html, b as attr } from "../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/state.svelte.js";
import { M as Modal } from "../../../../chunks/Modal.js";
import { g as getToastState } from "../../../../chunks/Toast.svelte.js";
function _page($$payload, $$props) {
  push();
  const { data, form } = $$props;
  getToastState();
  let showEditModal = false;
  let showPasswordModal = false;
  let name = data.user?.name || "";
  let email = data.user?.email || "";
  let phone = data.user?.phoneNumber || "";
  let idNumber = data.user?.idNumber || "";
  let password = "";
  let oldPassword = "";
  let confirmPassword = "";
  let isUpdatingProfile = false;
  let isChangingPassword = false;
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    head($$payload2, ($$payload3) => {
      $$payload3.title = `<title>Admin Profile</title>`;
    });
    $$payload2.out.push(`<div class="m-1 grid grid-cols-1 gap-4 md:grid-cols-2"><div class="flex flex-col items-center justify-center p-4"><img src="/kenyaLawFavicon.png" alt="Admin Profile" class="h-24 w-24 rounded-full object-cover shadow-lg"/> <h2 class="mt-4 text-2xl font-semibold">Admin: ${escape_html(name)}</h2></div> <div class="p-4"><p class="mb-2 text-lg text-gray-900">Email: ${escape_html(email)}</p> <p class="mb-2 text-lg text-gray-900">Phone: ${escape_html(phone)}</p> <p class="mb-2 text-lg text-gray-900">ID Number: ${escape_html(idNumber)}</p> <div class="mt-4 space-x-2"><button type="button" class="bg-fadeblack rounded-md px-3 py-2 text-white hover:bg-black">Edit Profile</button> <button type="button" class="bg-fadeblack rounded-md px-3 py-2 text-white hover:bg-black">Change Password</button></div></div> `);
    Modal($$payload2, {
      title: "Edit Admin Profile",
      modalClass: "max-w-md",
      get show() {
        return showEditModal;
      },
      set show($$value) {
        showEditModal = $$value;
        $$settled = false;
      },
      children: ($$payload3) => {
        $$payload3.out.push(`<form method="POST" action="?/editProfile" class="space-y-4"><div><label for="name" class="block text-sm font-semibold">Name</label> <input type="text" id="name" name="name" class="w-full rounded-md border p-2"${attr("value", name)}/></div> <div><label for="email" class="block text-sm font-semibold">Email</label> <input type="email" id="email" name="email" class="w-full rounded-md border p-2"${attr("value", email)}/></div> <div><label for="phone" class="block text-sm font-semibold">Phone</label> <input type="text" id="phone" name="phone" class="w-full rounded-md border p-2"${attr("value", phone)}/></div> <div><label for="idNumber" class="block text-sm font-semibold">ID Number</label> <input type="text" id="idNumber" name="idNumber" class="w-full rounded-md border p-2"${attr("value", idNumber)}/></div> `);
        if (form?.errors) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p class="text-sm text-red-500">${escape_html(form.errors)}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--> <button type="submit" class="bg-fadeblack flex w-full items-center justify-center rounded-md p-2 text-white hover:bg-black"${attr("disabled", isUpdatingProfile, true)}>`);
        {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--> Save Changes</button></form>`);
      },
      $$slots: { default: true }
    });
    $$payload2.out.push(`<!----> `);
    Modal($$payload2, {
      title: "Change Admin Password",
      modalClass: "max-w-md",
      get show() {
        return showPasswordModal;
      },
      set show($$value) {
        showPasswordModal = $$value;
        $$settled = false;
      },
      children: ($$payload3) => {
        $$payload3.out.push(`<form method="POST" action="?/changePassword" class="space-y-4"><div><label for="oldPassword" class="block text-sm font-semibold">Old Password</label> <input type="password" id="oldPassword" name="oldPassword" class="w-full rounded-md border p-2"${attr("value", oldPassword)}/></div> <div><label for="password" class="block text-sm font-semibold">New Password</label> <input type="password" id="password" name="password" class="w-full rounded-md border p-2"${attr("value", password)}/></div> <div><label for="confirmPassword" class="block text-sm font-semibold">Confirm Password</label> <input type="password" id="confirmPassword" name="confirmPassword" class="w-full rounded-md border p-2"${attr("value", confirmPassword)}/> `);
        {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> `);
        if (form?.errors) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p class="text-sm text-red-500">${escape_html(form.errors)}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--> <button type="submit" class="bg-fadeblack flex w-full items-center justify-center rounded-md p-2 text-white hover:bg-black"${attr("disabled", isChangingPassword, true)}>`);
        {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--> Update Password</button></form>`);
      },
      $$slots: { default: true }
    });
    $$payload2.out.push(`<!----></div>`);
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  pop();
}
export {
  _page as default
};
